import script from "./SpAlertsLinks.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpAlertsLinks.vue?vue&type=script&lang=ts&setup=true"

import "./SpAlertsLinks.vue?vue&type=style&index=0&id=0dae270b&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dae270b"]])

export default __exports__